import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';

import css from './TransactionPanel.css';

const ApplicationBanner = props => {
  const { onOpenApplicationModal } = props;

  return (
    <button type="button" className={css.applicationBannerButton} onClick={onOpenApplicationModal}>
      <FormattedMessage id="TransactionPanel.showApplicationButton" />
    </button>
  );
};

ApplicationBanner.propTypes = {
  onOpenApplicationModal: PropTypes.func.isRequired,
};

export default ApplicationBanner;
